
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Brain, Loader2 } from 'lucide-react';

interface AnalysisCardButtonProps {
  isGenerating: boolean;
  canAfford: boolean;
  onGenerate: () => void;
}

export function AnalysisCardButton({ isGenerating, canAfford, onGenerate }: AnalysisCardButtonProps) {
  return (
    <Button 
      onClick={onGenerate}
      disabled={isGenerating || !canAfford}
      className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 disabled:opacity-50"
      size="lg"
    >
      <AnimatePresence mode="wait">
        {isGenerating ? (
          <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="flex items-center"
          >
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Gerando análise...
          </motion.div>
        ) : (
          <motion.div
            key="generate"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="flex items-center"
          >
            <Brain className="mr-2 h-4 w-4" />
            Gerar Análise Avançada
          </motion.div>
        )}
      </AnimatePresence>
    </Button>
  );
}
